import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NotificationItemComponentBase } from './core/notification-item-component-base';

/** Represents an Skill Coach Assignment Reminder notification */
@Component({
  selector: 'dgx-assignment-reminder',
  template: '<span [innerHTML]="safeContent"></span>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentReminderComponent extends NotificationItemComponentBase {
  protected buildTemplate() {
    const contentResource =
      this.params.status === 'DueSoon'
        ? // [Assignment Name] is due soon
          'Team_AssignmentNameDueSoon'
        : // [Assignment Name] is overdue
          'Team_AssignmentNameOverdue';

    const title = this.itemService.translate.instant(contentResource, {
      assignmentName: this.titleArgument,
    });

    return this.itemService.sanitizer.bypassSecurityTrustHtml(
      `<span class="font-semibold">${title}</span>`
    );
  }
}
